
import { Product } from "@/types/product";

export const structuralProducts: Product[] = [
  {
    id: "coolant-elbow",
    name: "COOLANT ELBOW",
    description: "Liquid solutions used in a vehicle's cooling system to regulate engine temperature and prevent overheating or corrosion. Our coolant formulas contain high-performance additives that protect against rust, corrosion, and extreme temperatures, ensuring long-lasting engine efficiency and protection.",
    images: ["/assets/coolant-elbow/29.webp", "/assets/coolant-elbow/30.webp", "/assets/coolant-elbow/31.webp"],
    certifications: ["ISO 9001:2015"],
    minOrderQuantity: "100 units",
    availableFor: ["ECCO"],
    shippingPorts: ["Dubai", "Mombasa", "Rotterdam"],
    metaDescription: "Trusted Coolant Elbow exporter to Global Markets | ISO 9001:2015 Certified | 2024 Verified Supplier"
  },
  {
    id: "jack",
    name: "JACK",
    description: "Scissor Jack and Bottle Jack, lifting devices used to raise a vehicle for maintenance or tire changes. Designed with high-strength steel and precision engineering, our jacks ensure safe and stable lifting Which are easier to use.",
    images: ["/assets/jack/22.webp", "/assets/jack/23.webp", "/assets/jack/24.webp", "/assets/jack/25.webp"],
    certifications: ["ISO 9001:2015", "CE Certified"],
    minOrderQuantity: "100 units",
    availableFor: ["MARUTI", "TATA", "HYUNDAI", "CHEVROLET", "TOYOTA", "MAHINDRA", "ISUZU", "WIN"],
    shippingPorts: ["Dubai", "Mombasa", "Rotterdam"],
    metaDescription: "Trusted Jack exporter to Global Markets | ISO 9001:2015, CE Certified | 2024 Verified Supplier"
  },
  {
    id: "rear-axle",
    name: "REAR AXLE",
    description: "Structural shafts that connect the wheels and transmit power from the engine to move the vehicle forward. Constructed from heavy-duty alloy steel, our rear axles provide exceptional strength, load-bearing capacity, and wear resistance, ensuring durability even under high-stress conditions.",
    images: ["/assets/rear-axle/1.webp"],
    certifications: ["ISO 9001:2015", "TS 16949"],
    minOrderQuantity: "100 units",
    availableFor: ["TOYOTA", "CHEVROLET", "MARUTI", "ASHOK LEYLAND", "MAHINDRA", "TATA"],
    shippingPorts: ["Dubai", "Mombasa", "Rotterdam"],
    metaDescription: "Trusted Rear Axle exporter to Global Markets | ISO 9001:2015, TS 16949 Certified | 2024 Verified Supplier"
  },
  {
    id: "stepney-bracket",
    name: "STEPNEY BRACKET",
    description: "Sturdy metal brackets used to hold a spare tire securely in place. Made from galvanized steel or aluminum, our stepney brackets offer superior strength, corrosion resistance, and secure mounting for spare wheels in various vehicle models.",
    images: ["/assets/stepney-bracket/1.webp"],
    certifications: ["ISO 9001:2015"],
    minOrderQuantity: "100 units",
    availableFor: ["CHEVROLET", "TOYOTA", "MAHINDRA", "TATA", "FORCE"],
    shippingPorts: ["Dubai", "Mombasa", "Rotterdam"],
    metaDescription: "Trusted Stepney Bracket exporter to Global Markets | ISO 9001:2015 Certified | 2024 Verified Supplier"
  },
  {
    id: "door-hinge",
    name: "DOOR HINGE",
    description: "These essential components allow smooth opening and closing of vehicle doors, ensuring safety and convenience. Our door hinges are made from heavy-duty stainless steel or reinforced aluminium, offering excellent corrosion resistance, durability, and precise alignment for long-term use.",
    images: ["/assets/door-hinge/1.webp"],
    certifications: ["ISO 9001:2015"],
    minOrderQuantity: "100 units",
    availableFor: ["CHEVROLET", "HYUNDAI", "MAHINDRA", "MARUTI", "TATA", "TOYOTA"],
    shippingPorts: ["Dubai", "Mombasa", "Rotterdam"],
    metaDescription: "Trusted Door Hinge exporter to Global Markets | ISO 9001:2015 Certified | 2024 Verified Supplier"
  }
];
